module.exports = "<div class=\"loader\" *ngIf=\"isLoading\">Loading...</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = ./src/app/loader/loader.component.html
// module chunks = main